import * as Model from "@effect/sql/Model";
import { Schema } from "effect";
import { LoopCorrelation, LoopEngineMode } from "./LoopInvocation.ts";

/**
 * The `Cause` kind a `NodeLeft` decision carries when a node did not succeed:
 * it failed, was interrupted, or died.
 *
 * @since 1.0.0
 */
export const LoopDecisionCause = Schema.Literal("fail", "interrupt", "die");
export type LoopDecisionCause = Schema.Schema.Type<typeof LoopDecisionCause>;

/**
 * Loop decision model — one row of the append-only decision log, the durable
 * projection of one interpreter `LoopEvent` (OL-203).
 *
 * `at` is the interpreter's logical clock in milliseconds — a `Number` here, a
 * `bigint` in the column. `customerId` / `invocationId` are by id only.
 *
 * @since 1.0.0
 */
export class LoopDecision extends Model.Class<LoopDecision>("LoopDecision")({
  id: Model.Generated(Schema.String),

  customerId: Schema.String,

  invocationId: Schema.String,
  seq: Schema.Number,

  at: Schema.Number,

  tag: Schema.String,
  node: Schema.NullOr(Schema.String),
  fromNode: Schema.NullOr(Schema.String),
  toNode: Schema.NullOr(Schema.String),
  reason: Schema.NullOr(Schema.String),
  verdict: Schema.NullOr(Schema.String),
  cause: Schema.NullOr(LoopDecisionCause),
  attempt: Schema.NullOr(Schema.Number),
  claim: Schema.NullOr(Schema.String),
  head: Schema.NullOr(Schema.Unknown),
  detail: Schema.NullOr(Schema.Unknown),

  correlation: LoopCorrelation,
  mode: LoopEngineMode,

  createdAt: Model.DateTimeInsertFromDate,
}) {}
